class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector("button");
    const content = button?.nextElementSibling;
    const collapsibleGroup = this.dataset.group;

    // Helper function to toggle collapse
    const toggleCollapse = (btn, cnt, expanded) => {
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      cnt.setAttribute("aria-hidden", expanded ? "false" : "true");
    };

    // Debounce function to prevent multiple rapid clicks
    let isAnimating = false;
    const handleClick = () => {
      if (isAnimating) return;
      isAnimating = true;

      const ariaExpanded = button.getAttribute("aria-expanded") === "true";

      if (collapsibleGroup) {
        const groupElements = this.parentElement.querySelectorAll(`[data-group="${collapsibleGroup}"]`);

        groupElements.forEach((element) => {
          const groupButton = element.querySelector("button");
          const groupContent = groupButton?.nextElementSibling;

          if (element === this) {
            toggleCollapse(groupButton, groupContent, !ariaExpanded);
          } else {
            toggleCollapse(groupButton, groupContent, false);
          }
        });

      } else {
        toggleCollapse(button, content, !ariaExpanded);
      }

      // Allow animations to complete before next click
      setTimeout(() => {
        isAnimating = false;
      }, 300); // adjust timeout to match animation duration if necessary
    };

    button.addEventListener("click", handleClick);
  }
}

customElements.define("collapsible-content", CollapsibleContent);
